module.exports = __webpack_public_path__ + "img/lunbotu3.213dd4bc.png";